export default __webpack_public_path__ + "static/media/018-video camera.03508224.svg";